module.exports = __webpack_public_path__ + "assets/belgium.cec7b233.svg";